import React, { useMemo, useState } from "react";
import RfmModalBase from "./RfmModalBase";

export default function RfmReservationModal({ open, onClose, tables = [], onCreate }) {
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [guests, setGuests] = useState(2);
  const [date, setDate] = useState("");
  const [time, setTime] = useState("");
  const [tableId, setTableId] = useState("");
  const [email, setEmail] = useState("");
  const [note, setNote] = useState("");
  const availableTables = useMemo(() => tables.filter((t) => t.status === "available"), [tables]);
  const canSubmit = useMemo(() => name.trim().length > 0, [name]);

  const submit = () => {
    if (!canSubmit) return;
    onCreate?.({
      name: name.trim(),
      phone,
      guests: Number(guests) || 2,
      date,
      time,
      tableId: tableId || null,
      email: email.trim() || null,
      note: note,
      status: "CONFIRMED"
    });
    setName(""); setPhone(""); setGuests(2); setDate(""); setTime(""); setTableId("");
    setNote(""); setEmail("");
    onClose?.();
  };

  return (
    <RfmModalBase
      open={open}
      title="Nueva Reservación"
      onClose={onClose}
      footer={
        <>
      <div className="ord-footer">
            <button className="ord-btn ord-btn-secondary" type="button" onClick={onClose}>
              Cancelar
            </button>
            <button className="ord-btn ord-btn-primary" type="button" onClick={submit} disabled={!canSubmit}>
              <i className="bi bi-plus-lg" /> Crear Reservación
            </button>
          </div>
        </>
      }
    >
      <div className="rfm-form-row">
        <div className="rfm-form-group">
          <label className="rfm-form-label">Nombre del cliente</label>
          <input className="rfm-form-input" value={name} onChange={(e) => setName(e.target.value)} placeholder="Nombre completo" />
        </div>
        <div className="rfm-form-group">
          <label className="rfm-form-label">Correo electrónico</label>
          <input className="rfm-form-input" type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="correo@ejemplo.com" />
        </div>
      </div>

      <div className="rfm-form-row">
        <div className="rfm-form-group">
          <label className="rfm-form-label">Teléfono</label>
          <input className="rfm-form-input" value={phone} onChange={(e) => setPhone(e.target.value)} placeholder="+507..." />
        </div>
        <div className="rfm-form-group">
          <label className="rfm-form-label">Personas</label>
          <input className="rfm-form-input" type="number" min={1} value={guests} onChange={(e) => setGuests(e.target.value)} />
        </div>
      </div>

      <div className="rfm-form-row">
        <div className="rfm-form-group">
          <label className="rfm-form-label">Fecha</label>
          <input className="rfm-form-input" type="date" value={date} onChange={(e) => setDate(e.target.value)} />
        </div>
        <div className="rfm-form-group">
          <label className="rfm-form-label">Hora</label>
          <input className="rfm-form-input" type="time" value={time} onChange={(e) => setTime(e.target.value)} />
        </div>
      </div>

      <div className="rfm-form-group">
        <label className="rfm-form-label">Mesa</label>
        <select className="rfm-form-input" value={tableId} onChange={(e) => setTableId(e.target.value)}>
          <option value="">Auto-asignar</option>
          {availableTables.map((t) => (
            <option key={t.id} value={t.id}>
              Mesa {t.number}
            </option>
          ))}
        </select>
      </div>

      <div className="rfm-form-group">
        <label className="rfm-form-label">Nota</label>
        <textarea className="rfm-form-input" value={note} onChange={(e) => setNote(e.target.value)} placeholder="Notas adicionales" />
      </div>
    </RfmModalBase>
  );
}
